export default __webpack_public_path__ + "static/media/coconut.6440cae7.png";